<div class="title-section border-bottom d-flex flex-column justify-content-center align-items-center">
  <div class="title-visual" aria-hidden="true">
    <img class="title-illustration" src="../../assets/title-section-illustration.svg" width="1600" height="620" alt="">
  </div>
  <div class="container position-relative z-1">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6 text-center">
        <h1 class="mb-3">Start building with Ping Identity.</h1>
        <p class="lead text-gray-900">Find downloads, technical learning, and product resources all in one place.</p>
      </div>
      <div class="col-12 col-md-10 col-lg-7">
        <backstage-global-search-bar></backstage-global-search-bar>
      </div>
    </div>
  </div>
</div>
<div class="">
  <div class="z-1 position-relative">
    @if (maintenanceMode) {
      <div class="container my-5">
        <div class="row">
          <div class="col-12">
            <app-dashboard-maintenance-info-panel/>
          </div>
        </div>
      </div>
    }

    @if (isEmailUnverified$ | async) {
      <div class="container my-5">
        <div class="row">
          <div class="col-12">
            <app-dashboard-verify-email-panel [emailVerifiedUntil]="emailVerifiedUntil$ | async"/>
          </div>
        </div>
      </div>
    }

    <div class="container my-5">
      <div class="row">
        <div class="col-12">
          <app-dashboard-links-panel/>
        </div>
      </div>
    </div>

    <div class="bg-gray-100">
      <div class="container py-5">
        <app-dashboard-university-panel/>
      </div>
    </div>

    <div class="container my-5">
      <div class="row">
        <div class="col-12">
          <app-dashboard-downloads-panel/>
        </div>
      </div>
    </div>
  </div>
</div>
